import { ContactShadows, Environment, useGLTF } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import { useEffect, useMemo } from 'react'
import { Fog } from 'three'

import { useResourceUrl } from '@salsita-ai/platform-project-sdk/react'

import { configuratorInterface } from './systems/configurator-interface'

export const AppEnvironment = () => {
  const { gl, scene } = useThree()
  const { getResourceUrl } = useResourceUrl()

  const { domain } = configuratorInterface.useDomain()
  const renderedState = configuratorInterface.useRenderedState()
  const $room = domain.getRoot$Entity(renderedState)

  const environmentFileUrl = useMemo(
    () => getResourceUrl('/environments/interior_haussmannian_front_day_light_07.hdr'),
    [getResourceUrl]
  )

  useGLTF.preload(getResourceUrl('models/jms.glb'))

  useEffect(() => {
    gl.toneMappingExposure = 1
    scene.fog = new Fog(0xf3f2ef, $room.$cameraMaxDistance! + 2000, $room.$cameraMaxDistance! + 10000)
  }, [gl, scene, $room.$cameraMaxDistance])

  return (
    <>
      <directionalLight position={[0, 2000, 3000]} intensity={1} color="#f8f8e1" />
      <directionalLight position={[0, 2000, -3000]} intensity={1} color="#f9f3d0" />
      <directionalLight position={[2000, 2000, 0]} intensity={1} color="#fffdef" />
      <directionalLight position={[-2000, 15000, 1000]} intensity={3} />
      <ambientLight intensity={0.7} />
      <Environment files={environmentFileUrl} />
      <ContactShadows
        position={[0, 0, -10]}
        blur={0.2}
        opacity={0.7}
        near={0}
        far={10000}
        width={10000}
        height={10000}
        color="#3c372f"
      />
    </>
  )
}
